/**
 * 标签(badge)配色: 资源标签与会员状态.
 *
 * 资源标签内容自由、数量不定, 不做逐标签配色, 统一用主题的中性强调色;
 * 会员状态使用主题强调色与中性 soft 徽章, 与其它状态徽章保持一致.
 */

/** 资源标签: 统一样式, 背景与文字色都取自现有主题 token */
export const TAG_BADGE_CLASS = 'badge badge-sm border-transparent bg-brand-tint text-primary'

/** 免费资源标记: 与其它状态徽章一致用 soft 样式, 放在卡片标签行右侧 */
export const FREE_BADGE_CLASS = 'badge badge-sm badge-soft badge-success'

/** 会员状态: 有效 / 未开通(或已过期) */
export function memberBadgeClass(isMember: boolean): string {
  return isMember
    ? 'badge-soft badge-primary'
    : 'badge-soft badge-neutral'
}
